/**
 * @generated SignedSource<<ba8b797ebea6cbd7497ca48d6175c42d>>
 * @relayHash 3ad06033831786b2426f440216af4183
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dceb569235fb03654e9ba7d4d1da56b780529ae35fbc83e4afd6774811360268

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { backlogFilterRefinementQuery } from './backlogFilterRefinementQuery.graphql';

const node: PreloadableConcreteRequest<backlogFilterRefinementQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "dceb569235fb03654e9ba7d4d1da56b780529ae35fbc83e4afd6774811360268",
    "metadata": {},
    "name": "backlogFilterRefinementQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
